import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { template } from 'lodash';
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';

declare var $: any, moment: any

@Component({
  selector: 'app-pool-case',
  templateUrl: './pool-case.component.html',
  styleUrls: ['./pool-case.component.scss']
})
export class PoolCaseComponent implements OnInit {

  caseID = ""
  caseTicket = ""

  sharedHigh = 0
  sharedMedium = 0
  sharedLow = 0
  socialHigh = 0
  socialMedium = 0
  socialLow = 0

  sharedCaseList: any = []
  socialCaseList: any = []
  tmpSharedCaseList: any = []
  tmpSocialCaseList: any = []

  caseStatusList: any

  caseTypeList: any
  subTypeTmpList: any

  caseSubTypeSharedList: any = []
  caseSubTypeSocialList: any = []

  subTypeDetailTmpList: any

  caseSubTypeDetailSharedList: any = []
  caseSubTypeDetailSocialList: any = []

  caseNoShared: string = ""
  firstnameShared: string = ""
  lastnameShared: string = ""
  telephoneShared: string = ""
  caseTypeShared: string = ""
  caseSubTypeShared: string = ""
  subTypeDetailShared: string = ""
  statusShared: string = ""

  caseTypeMy: string = ""
  caseSubTypeMy: string = ""
  subTypeDetailMy: string = ""
  statusMy: string = ""

  caseNoSocial: string = ""
  firstnameSocial: string = ""
  lastnameSocial: string = ""
  telephoneSocial: string = ""
  caseTypeSocial: string = ""
  caseSubTypeSocial: string = ""
  subTypeDetailSocial: string = ""
  statusSocial: string = ""

  dtSharedCase: any = null
  dtSocialCase: any = null

  role: any = {}
  cookieData: any

  myTeams: any

  isTakeTeamCase = false
  isTakeSocialCase = false

  constructor(
    private router: Router,
    private apiService: ApiService,
    private util: UtilService
  ) { }

  async ngOnInit() {
    let thisTs = this
    this.util.ShowWaiting(true)
    this.util.InitValidation()

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)
    this.myTeams = JSON.parse(this.cookieData.teams)

    //await this.callApi()
    this.callApi()

    $('#dateFromShared').on('changeDate', function (ev: any) {
      $('#dateToShared').datepicker('setStartDate', ev.date);
    });
    $('#dateToShared').on('changeDate', function (ev: any) {
      $('#dateFromShared').datepicker('setEndDate', ev.date);
    });
    $('#dateFromSocial').on('changeDate', function (ev: any) {
      $('#dateToSocial').datepicker('setStartDate', ev.date);
    });
    $('#dateToSocial').on('changeDate', function (ev: any) {
      $('#dateFromSocial').datepicker('setEndDate', ev.date);
    });

    this.util.ShowWaiting(false)
  }

  callApi() {
    let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
    let sharedPara = ""
    let socialPara = ""

    if (this.role.dpa_list_sharecase) {
      sharedPara = "case_date_from=" + tmpDate + "&casestatuscode=01,02"
      if (this.myTeams != null && this.myTeams.length > 0) {
        this.myTeams.forEach((t: any) => {
          sharedPara += (sharedPara.length > 0 ? "&" : "") + "callcenterteam=" + t.dpa_callcenterteamid
        });
      }
    }
    if (this.role.dpa_list_nonvoicepool) {
      socialPara = "case_date_from=" + tmpDate + "&casestatuscode=01"
      socialPara += "&casechannelcode=02,03,04,05"
    }

    Observable.forkJoin(
      this.apiService.get("master", "caseStatus"),
      this.apiService.get("master", "caseType"),
      this.apiService.get("master", "caseSubType"),
      this.apiService.get("master", "caseSubTypeDetail"),
      this.apiService.get("crmservice", "caseIncident", sharedPara),
      this.apiService.get("crmservice", "caseIncident", socialPara)
    ).subscribe(
      data => {
        this.caseStatusList = data[0]
        this.caseTypeList = data[1]
        this.subTypeTmpList = data[2]
        this.subTypeDetailTmpList = data[3]
        this.tmpSharedCaseList = data[4]
        this.tmpSocialCaseList = data[5]

        this.BindCase()
        this.util.ShowWaiting(false)
      },
      err => {
        console.error(err)
        this.util.ShowWaiting(false)
      }
    );

  }

  async BindCase() {
    this.sharedHigh = this.sharedMedium = this.sharedLow = 0
    this.socialHigh = this.socialMedium = this.socialLow = 0
    this.tmpSharedCaseList.forEach((c: any) => {
      if (c.dpa_caseowner == null) {
        this.sharedCaseList.push(c)
        if (c.dpa_caseseverityidname != null) {
          if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
            this.sharedHigh++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
            this.sharedMedium++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
            this.sharedLow++
          }
        }
      }

    });

    for(var i = 0; i < this.sharedCaseList.length; i++)
    {
      let order = 0  ;let orderpri  = 0
      if(this.sharedCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
      {
        order = 1;
      }
      else if(this.sharedCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
      {
        order = 2;
      }
      else if(this.sharedCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
      {
        order = 3;
      }
      else if(this.sharedCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
      {
        order = 4;
      }
      else if(this.sharedCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
      {
        order = 5;
      }
      else
      {
        order = 6;
      }

      if (this.sharedCaseList[i].dpa_caseseverityidname != null)  
      {
        if (this.sharedCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          orderpri = 1;
        }
        else if (this.sharedCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          orderpri = 2;
        }
        else if (this.sharedCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          orderpri = 3;
        } 
        else {
          orderpri = 4;
        }
      }
      else 
      {
        orderpri = 4;
      }
  

      this.sharedCaseList[i].ordercase = order ;
      this.sharedCaseList[i].orderpri = orderpri ;

    }
   // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));


   try{
    /*
    tmp.sort(
      (firstObject: any, secondObject: any) =>
        (firstObject.orderpri < secondObject.orderpri) ? 1 :
          (firstObject.orderpri == secondObject.orderpri) ? (
            (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
              (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? (
                (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                  (new Date(firstObject.dpa_slatime.substring(0, 10))== new Date(secondObject.dpa_slatime.substring(0, 10))) ? ( 
                        (firstObject.ordercase  > secondObject.ordercase ) ? 1 : 
                -1 )
                :-1
              -1 )
              :-1
          -1 )
        : -1
      ); 
      */
      this.sharedCaseList.sort((firstObject: any, secondObject: any) => (firstObject.orderpri - secondObject.orderpri 
                                                        || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                                                        || new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                                                        || firstObject.ordercase - secondObject.ordercase  
                                                        ));
    }
    catch
    {

    }



    this.tmpSocialCaseList.forEach((c: any) => {
      if (c.dpa_caseowner == null) {
        this.socialCaseList.push(c)
        if (c.dpa_caseseverityidname != null) {
          if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
            this.socialHigh++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
            this.socialMedium++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
            this.socialLow++
          }
        }
      }
    });

    for(var i = 0; i < this.socialCaseList.length; i++)
    {
      let order = 0  ;let orderpri  = 0
      if(this.socialCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
      {
        order = 1;
      }
      else if(this.socialCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
      {
        order = 2;
      }
      else if(this.socialCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
      {
        order = 3;
      }
      else if(this.socialCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
      {
        order = 4;
      }
      else if(this.socialCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
      {
        order = 5;
      }
      else
      {
        order = 6;
      }

      if (this.socialCaseList[i].dpa_caseseverityidname != null)  
      {
        if (this.socialCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          orderpri = 1;
        }
        else if (this.socialCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          orderpri = 2;
        }
        else if (this.socialCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          orderpri = 3;
        } 
        else {
          orderpri = 4;
        }
      }
      else 
      {
        orderpri = 4;
      }
  

      this.socialCaseList[i].ordercase = order ;
      this.socialCaseList[i].orderpri = orderpri ;

    }
   // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));


   try{
    /*
    tmp.sort(
      (firstObject: any, secondObject: any) =>
        (firstObject.orderpri < secondObject.orderpri) ? 1 :
          (firstObject.orderpri == secondObject.orderpri) ? (
            (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
              (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? (
                (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                  (new Date(firstObject.dpa_slatime.substring(0, 10))== new Date(secondObject.dpa_slatime.substring(0, 10))) ? ( 
                        (firstObject.ordercase  > secondObject.ordercase ) ? 1 : 
                -1 )
                :-1
              -1 )
              :-1
          -1 )
        : -1
      ); 
      */
      this.sharedCaseList.sort((firstObject: any, secondObject: any) => (firstObject.orderpri - secondObject.orderpri 
                                                        || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                                                        || new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                                                        || firstObject.ordercase - secondObject.ordercase  
                                                        ));
    }
    catch
    {

    }



    this.drawTableSharedCase()
    this.drawTableSocialCase()
  }

  async searchSharedCase(getAll: boolean = false) {
    this.util.ShowWaiting(true)
    this.sharedHigh = this.sharedMedium = this.sharedLow = 0
    if (!this.role.dpa_list_sharecase) {
      return
    }
    //this.util.ShowWaiting(true)

    $('#tbSharedCase').DataTable().clear().destroy();

    let filterd: any = []

    if (getAll) {
      let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
      let sharedPara = "case_date_from=" + tmpDate + "&casestatuscode=01,02"
      if (this.myTeams != null && this.myTeams.length > 0) {
        this.myTeams.forEach((t: any) => {
          sharedPara += (sharedPara.length > 0 ? "&" : "") + "callcenterteam=" + t.dpa_callcenterteamid
        });
      }
      filterd = await this.apiService.get("crmservice", "caseIncident", sharedPara)
    }
    else {
      let para = ""

      para = "casestatuscode=01,02"
      if (this.myTeams != null && this.myTeams.length > 0) {
        this.myTeams.forEach((t: any) => {
          para += (para.length > 0 ? "&" : "") + "callcenterteam=" + t.dpa_callcenterteamid
        });
      }

      let fromDtShared = $('#dateFromShared').val();
      let toDtShared = $('#dateToShared').val();

      if (this.caseNoShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "caseno=" + this.caseNoShared
      }
      if (this.firstnameShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameShared
      }
      if (this.lastnameShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameShared
      }
      if (this.telephoneShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "telephone=" + this.telephoneShared
      }


      if (this.caseTypeShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casetypeid=" + this.caseTypeShared
      }
      if (this.caseSubTypeShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casesubtypeid=" + this.caseSubTypeShared
      }
      if (this.subTypeDetailShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casesubtypedetailid=" + this.subTypeDetailShared
      }
      if (this.statusShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casestatusid=" + this.statusShared
      }


      if (fromDtShared != null && fromDtShared != "") {
        para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment(this.util.ConvertToAD(fromDtShared, true), "DD/MM/YYYY").format("YYYY-MM-DD")
      }

      if (toDtShared != null && toDtShared != "") {
        para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment(this.util.ConvertToAD(toDtShared, true), "DD/MM/YYYY").format("YYYY-MM-DD")
      }

      if (para.length > 0) {
        filterd = await this.apiService.get("crmservice", "caseIncident", para)
      }
      else {
        let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
        filterd = await this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)
      }
    }
    let tmp: any = []
    filterd.forEach((c: any) => {
      if (c.dpa_caseowner == null) { 
        tmp.push(c)
        if (c.dpa_caseseverityidname != null) {
          if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
            this.sharedHigh++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
            this.sharedMedium++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
            this.sharedLow++
          }
        }
      }
    });

    for(var i = 0; i < tmp.length; i++)
    {
      let order = 0  ;let orderpri  = 0
      if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
      {
        order = 1;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
      {
        order = 2;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
      {
        order = 3;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
      {
        order = 4;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
      {
        order = 5;
      }
      else
      {
        order = 6;
      }

      if (tmp[i].dpa_caseseverityidname != null)  
      {
        if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          orderpri = 1;
        }
        else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          orderpri = 2;
        }
        else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          orderpri = 3;
        } 
        else {
          orderpri = 4;
        }
      }
      else 
      {
        orderpri = 4;
      }
  

      tmp[i].ordercase = order ;
      tmp[i].orderpri = orderpri ;

    }
   // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));


   try{
    /*
    tmp.sort(
      (firstObject: any, secondObject: any) =>
        (firstObject.orderpri < secondObject.orderpri) ? 1 :
          (firstObject.orderpri == secondObject.orderpri) ? (
            (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
              (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? (
                (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                  (new Date(firstObject.dpa_slatime.substring(0, 10))== new Date(secondObject.dpa_slatime.substring(0, 10))) ? ( 
                        (firstObject.ordercase  > secondObject.ordercase ) ? 1 : 
                -1 )
                :-1
              -1 )
              :-1
          -1 )
        : -1
      ); 
      */
      tmp.sort((firstObject: any, secondObject: any) => (firstObject.orderpri - secondObject.orderpri 
                                                        || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                                                        || new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                                                        || firstObject.ordercase - secondObject.ordercase  
                                                        ));
    }
    catch
    {

    }


    this.sharedCaseList = tmp
    
    

    this.drawTableSharedCase()
    this.util.ShowWaiting(false)
  }

  async searchSocialCase() {
    this.socialHigh = this.socialMedium = this.socialLow = 0
    if (!this.role.dpa_list_nonvoicepool) {
      return
    }
    //this.util.ShowWaiting(true)

    $('#tbSocialCase').DataTable().clear().destroy();

    let para = ""
    
    para = "casestatuscode=01&casechannelcode=02,03,04,05"

    let fromDtSocial = $('#dateFromSocial').val();
    let toDtSocial = $('#dateToSocial').val();

    if (this.caseNoSocial.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "caseno=" + this.caseNoSocial
    }
    if (this.firstnameSocial.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameSocial
    }
    if (this.lastnameSocial.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameSocial
    }
    if (this.telephoneSocial.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "telephone=" + this.telephoneSocial
    }

    if (this.caseTypeSocial.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "casetypeid=" + this.caseTypeSocial
    }
    if (this.caseSubTypeSocial.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "casesubtypeid=" + this.caseSubTypeSocial
    }
    if (this.subTypeDetailSocial.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "casesubtypedetailid=" + this.subTypeDetailSocial
    }
    if (this.statusSocial.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "casestatusid=" + this.statusSocial
    }


    if (fromDtSocial != null && fromDtSocial != "") {
      para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment(this.util.ConvertToAD(fromDtSocial, true), "DD/MM/YYYY").format("YYYY-MM-DD")
    }

    if (toDtSocial != null && toDtSocial != "") {
      para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment(this.util.ConvertToAD(toDtSocial, true), "DD/MM/YYYY").format("YYYY-MM-DD")
    }


    let filterd: any = []
    if (para.length > 0) {
      filterd = await this.apiService.get("crmservice", "caseIncident", para)
    }
    else {
      let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
      filterd = await this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)
    }

    let tmp: any = []

    filterd.forEach((c: any) => {
      if (c.dpa_caseowner == null) {
        tmp.push(c)
        if (c.dpa_caseseverityidname != null) {
          if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
            this.socialHigh++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
            this.socialMedium++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
            this.socialLow++
          }
        }
      }
    });

    for(var i = 0; i < tmp.length; i++)
    {
      let order = 0  ;let orderpri  = 0
      if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
      {
        order = 1;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
      {
        order = 2;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
      {
        order = 3;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
      {
        order = 4;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
      {
        order = 5;
      }
      else
      {
        order = 6;
      }

      if (tmp[i].dpa_caseseverityidname != null)  
      {
        if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          orderpri = 1;
        }
        else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          orderpri = 2;
        }
        else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          orderpri = 3;
        } 
        else {
          orderpri = 4;
        }
      }
      else 
      {
        orderpri = 4;
      }
  

      tmp[i].ordercase = order ;
      tmp[i].orderpri = orderpri ;

    }
   // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));


   try{
    /*
    tmp.sort(
      (firstObject: any, secondObject: any) =>
        (firstObject.orderpri < secondObject.orderpri) ? 1 :
          (firstObject.orderpri == secondObject.orderpri) ? (
            (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
              (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? (
                (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                  (new Date(firstObject.dpa_slatime.substring(0, 10))== new Date(secondObject.dpa_slatime.substring(0, 10))) ? ( 
                        (firstObject.ordercase  > secondObject.ordercase ) ? 1 : 
                -1 )
                :-1
              -1 )
              :-1
          -1 )
        : -1
      ); 
      */
      tmp.sort((firstObject: any, secondObject: any) => (firstObject.orderpri - secondObject.orderpri 
                                                        || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                                                        || new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                                                        || firstObject.ordercase - secondObject.ordercase  
                                                        ));
    }
    catch
    {

    }

    

    this.socialCaseList = tmp 

    this.drawTableSocialCase()
    //this.util.ShowWaiting(false)
  }

  resetSearchSharedCase() {
    this.caseNoShared = ""
    this.firstnameShared = ""
    this.lastnameShared = ""
    this.telephoneShared = ""

    this.caseTypeShared = ""
    this.caseSubTypeShared = ""
    this.subTypeDetailShared = ""
    this.statusShared = ""

    this.caseSubTypeSharedList = []
    this.caseSubTypeDetailSharedList = []

    $('#dateFromShared').val("").datepicker("update");
    $('#dateToShared').val("").datepicker("update");
  }

  resetSearchSocialCase() {
    this.caseNoSocial = ""
    this.firstnameSocial = ""
    this.lastnameSocial = ""
    this.telephoneSocial = ""

    this.caseTypeSocial = ""
    this.caseSubTypeSocial = ""
    this.subTypeDetailSocial = ""
    this.statusSocial = ""

    this.caseSubTypeSocialList = []
    this.caseSubTypeDetailSocialList = []

    $('#dateFromSocial').val("").datepicker("update");
    $('#dateToSocial').val("").datepicker("update");
  }

  // ngAfterViewInit() {
  //   this.tbShared.changes.subscribe(t => {
  //     this.initTableShared()
  //   })
  //   this.tbSocial.changes.subscribe(t => {
  //     this.initTableSocial()
  //   })
  // }

  // ngForRendred() {
  //   console.log('NgFor is Rendered');
  //   if (this.dtSocialCase == null) {
  //     this.initTableSocial()
  //   }
  //   if (this.dtSharedCase == null) {
  //     this.initTableShared()
  //   }
  // }

  initTableShared() {
    let thisTs = this

    $("#tbSharedCase tbody tr").on("click", function () {

      thisTs.caseID = $(this)[0].id
      thisTs.caseTicket = $(this).find(".col-id")[0].innerText

      thisTs.isTakeTeamCase = true
      thisTs.isTakeSocialCase = false

      $("#takeCaseModal").modal("show")

    });
    this.dtSharedCase = $("#tbSharedCase").dataTable({
      retrieve: true,
      'searching': false, 
      order: [],
      "drawCallback": function (settings: any) {
        console.log('DataTables shared has redrawn the table');
      }
    });
  }

  initTableSocial() {
    let thisTs = this
    $("#tbSocialCase tbody tr").on("click", function () {

      thisTs.caseID = $(this)[0].id
      thisTs.caseTicket = $(this).find(".col-id")[0].innerText

      thisTs.isTakeTeamCase = false
      thisTs.isTakeSocialCase = true

      $("#takeCaseModal").modal("show")
    });

    this.dtSocialCase = $("#tbSocialCase").dataTable({
      retrieve: true,
      'searching': false,
      "drawCallback": function (settings: any) {
        console.log('DataTables all has redrawn the table');
      }
    });
  }

  async takeCase() {
    this.util.ShowWaiting(true)
    let req: any
    if (this.isTakeTeamCase) {
      req = this.sharedCaseList.filter((c: any) => {
        return c.incidentid == this.caseID
      })
    }
    else {
      req = this.socialCaseList.filter((c: any) => {
        return c.incidentid == this.caseID
      })
    }

    req[0]["dpa_modifiedby"] = this.cookieData.userId
    req[0]["dpa_caseowner"] = this.cookieData.userId

    let res: any = await this.apiService.put("crmservice", "caseIncident-takeOwner/" + this.caseID, req[0])

    if (this.util.isSuccessResponse(res)) {
      $("#takeCaseModal").modal("hide")

      if (this.isTakeTeamCase) {
        await this.searchSharedCase(true)
      }
      else {
        await this.searchSocialCase()
      }

      this.util.ShowWaiting(false)
      this.util.SuccessDialog("รับเคสสำเร็จ")

      setTimeout(() => {
        const url = this.util.baseUrl() + `/caseDetail/` + this.caseTicket
        window.open(url, '_blank');
      }, 800);
    }
    else {
      this.util.ShowWaiting(false)
      this.util.ErrorDialog("รับเคสไม่สำเร็จ")
    }

  }

  onCaseTypeSocialChange() {
    if (this.caseTypeSocial != null && this.caseTypeSocial.length > 0) {
      this.caseSubTypeSocialList = this.subTypeTmpList.filter(
        (subType: any) => subType.dpa_casetypeid === this.caseTypeSocial)
    }
  }

  onCaseSubTypeSocialChange() {
    if (this.caseSubTypeSocial != null && this.caseSubTypeSocial.length > 0) {
      this.caseSubTypeDetailSocialList = this.subTypeDetailTmpList.filter(
        (subType: any) => subType.dpa_casesubtypeid === this.caseSubTypeSocial)
    }
  }

  onCaseTypeSharedChange() {
    if (this.caseTypeShared != null && this.caseTypeShared.length > 0) {
      this.caseSubTypeSharedList = this.subTypeTmpList.filter(
        (subType: any) => subType.dpa_casetypeid === this.caseTypeShared)
    }
  }

  onCaseSubTypeSharedChange() {
    if (this.caseSubTypeShared != null && this.caseSubTypeShared.length > 0) {
      this.caseSubTypeDetailSharedList = this.subTypeDetailTmpList.filter(
        (subType: any) => subType.dpa_casesubtypeid === this.caseSubTypeShared)
    }
  }

  drawTableSharedCase() {
    $("#tbSharedCase tbody").empty()
    this.sharedCaseList.forEach((c: any) => {
      let priority = ""
      let tr = ""

      if (c.dpa_caseseverityidname == null || c.dpa_caseseverityidname.trim() == "") {
        tr += '<tr id="' + c.incidentid + '">' +
          '<td align="center"></td>'
      }
      else {
        let severity = c.dpa_caseseverityidname.toLowerCase()
        if (severity == "high") {
          priority = "3"
        }
        else if (severity == "medium") {
          priority = "2"
        }
        else if (severity == "low") {
          priority = "1"
        }

        tr += '<tr id="' + c.incidentid + '">' +
          '<td align="center" data-sort="' + priority + '">' +
          '<span class="dot ' + severity + '"></span>' +
          '</td>'
      }

      tr += '<td class="col-id">' + c.ticketnumber + '</td>' +
        '<td>' + c.dpa_casesubtypeidname + '</td>' +
        '<td>' + c.customeridname + '</td>' +
        '<td>' + c.dpa_casechannelidname + '</td>' +
        '<td>' + c.dpa_casestatusidname + '</td>' +
        '<td><span class="sr-only">' + this.util.transformDate(c.createdon, 'fullWithoutDelimeter') + '</span>' +
        this.util.transformDate(c.createdon, 'shortWithTime') + '</td>'

      if (c.dpa_issla) {
        tr += '<td align="center" class="high">Over</td>'
      }
      else {
        if (c.dpa_warningtime != null && c.dpa_warningtime != "" && (moment(c.dpa_warningtime.replace("Z", "")) <= moment())) {
          tr += '<td align="center" class="low">Warning</td>'
        }
        else {
          tr += '<td align="center" class="high"></td>'
        }
      }

      tr += '<td><span class="sr-only">' + this.util.transformDate(c.dpa_slatime, 'fullWithoutDelimeter') + '</span>'
        + this.util.transformDate(c.dpa_slatime, 'shortWithTime') + '</td>' +
        '</tr>'
      $("#tbSharedCase tbody").append(tr);
    });

    this.initTableShared()
  }

  drawTableSocialCase() {
    $("#tbSocialCase tbody").empty()
    this.socialCaseList.forEach((c: any) => {
      let priority = ""
      let tr = ""

      if (c.dpa_caseseverityidname == null || c.dpa_caseseverityidname.trim() == "") {
        tr += '<tr id="' + c.incidentid + '">' +
          '<td align="center"></td>'
      }
      else {
        let severity = c.dpa_caseseverityidname.toLowerCase()
        if (severity == "high") {
          priority = "3"
        }
        else if (severity == "medium") {
          priority = "2"
        }
        else if (severity == "low") {
          priority = "1"
        }

        tr += '<tr id="' + c.incidentid + '">' +
          '<td align="center" data-sort="' + priority + '">' +
          '<span class="dot ' + severity + '"></span>' +
          '</td>'
      }

      tr += '<td class="col-id">' + c.ticketnumber + '</td>' +
        '<td>' + c.dpa_casesubtypeidname + '</td>' +
        '<td>' + c.customeridname + '</td>' +
        '<td>' + c.dpa_casechannelidname + '</td>' +
        '<td>' + c.dpa_casestatusidname + '</td>' +
        '<td><span class="sr-only">' + this.util.transformDate(c.createdon, 'fullWithoutDelimeter') + '</span>' +
        this.util.transformDate(c.createdon, 'shortWithTime') + '</td>'
      if (c.dpa_issla) {
        tr += '<td align="center" class="high">Over</td>'
      }
      else {
        if (c.dpa_warningtime != null && c.dpa_warningtime != "" && (moment(c.dpa_warningtime.replace("Z", "")) <= moment())) {
          tr += '<td align="center" class="low">Warning</td>'
        }
        else {
          tr += '<td align="center" class="high"></td>'
        }
      }

      tr += '<td><span class="sr-only">' + this.util.transformDate(c.dpa_slatime, 'fullWithoutDelimeter') + '</span>'
        + this.util.transformDate(c.dpa_slatime, 'shortWithTime') + '</td>' +
        '</tr>'
      $("#tbSocialCase tbody").append(tr);
    });

    this.initTableSocial()
  }

}



// WEBPACK FOOTER //
// ./src/app/pool-case/pool-case.component.ts